window.initLocations = function () {
    if (!$('#map').length) return;
    const locations = [];
    $('[data-location]').each(function () {
        locations.push($(this).data('location'));
    });
    if (!locations.length) return;
    var map_options = {
        //sizzle selector of the map div/element
        element: '#map',
        //initial zoom level of the map
        zoom: 10,
        //lat/lng of the initial center point of the map
        center: {
            lat: 41.3483056,
            lng: -91.1451721
        },
        //fit map zoom & location (bounds) to location points automatically
        fit_bounds: false,
        //style the map colors- see a full list of editable elements here:	https://developers.google.com/maps/documentation/javascript/styling#styling_the_default_map
        map_styles: [
            {
                "featureType": "administrative",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "color": "#969696"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#f7f7f7"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ececec"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#b4b4b4"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "color": "#bebebe"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "saturation": "0"
                    },
                    {
                        "lightness": "-8"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#b4b4b4"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dbdbdb"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#d8d8d8"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#dadada"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            }
        ],
        locations: locations // these are in footer.php
    }

    //now the magic...
    if ($(map_options.element).length > 0) {
        google.maps.visualRefresh = true; // Enable the visual refresh
        var map = new google.maps.Map($(map_options.element)[0], {
            center: new google.maps.LatLng(map_options.center.lat, map_options.center.lng),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            panControl: false,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: true,
            overviewMapControl: false,
            styles: map_options.map_styles,
            zoom: map_options.zoom,
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.SMALL
            }
        });
        var markers = [];
        var bounds = new google.maps.LatLngBounds();

        $(map_options.locations).each(function (i, el) {
            var location = this;
            var this_position = new google.maps.LatLng(location.position.lat, location.position.lng);
            var marker_options = {
                position: this_position,
                map: map,
                title: location.title,
                icon: map_markers[location.icon],
            };
            if (location.serviceRadius) {
                marker_options.serviceArea = new google.maps.Circle({
                    indexID: i,
                    strokeWeight: 0,
                    fillColor: '#818184',
                    fillOpacity: 0.25,
                    center: this_position,
                    radius: location.serviceRadius,
                });
            }
            else if (location.polygonPaths) {
                marker_options.serviceArea = new google.maps.Polygon({
                    indexID: i,
                    paths: location.polygonPaths,
                    strokeWeight: 0,
                    fillColor: '#818184',
                    fillOpacity: 0.25
                });
            }
            if (location.infowindow) {
                marker_options.infoWindow = new google.maps.InfoWindow({
                    content: '<div class="c-infowindow">' +
                        (location.img ? '<div class="c-infowindow__header"><img class="c-infowindow__img" src="' + location.img + '"></div>' : '') +
                        '<div class="c-infowindow__text"><div><h3>' + location.name + '</h3>' +
                        '<span>' + location.address + '<br />' + location.city + ', ' + location.state + ' ' + location.zip + '</span></div>' +
                        '<a class="c-infowindow__btn o-btn" href="' + location.directions + '" target="_blank">Get Directions</a></div>' +
                        '</div>'
                });

                google.maps.event.addListener(marker_options.infoWindow, 'closeclick', () => {
                    if (marker_options.serviceArea) {
                        marker_options.serviceArea.setMap(null);
                    }
                });
            }

            var marker = new google.maps.Marker(marker_options);
            markers.push(marker);
            google.maps.event.addListener(marker, 'click', function () {
                markers.forEach(m => {
                    m.infoWindow.close();
                    if (m.serviceArea) {
                        m.serviceArea.setMap(null);
                    }
                });
                if (marker.serviceArea) {
                    marker.serviceArea.setMap(map);
                }
                if (marker.infoWindow) {
                    marker.infoWindow.open(map, marker);
                }
            });
            bounds.extend(this_position);
        });


        if (map_options.fit_bounds) {
            map.fitBounds(bounds);
        }

        $(window).resize(function () {
            resetMap(map);
        });


    }

    function resetMap(m) {
        x = m.getZoom();
        c = m.getCenter();
        google.maps.event.trigger(m, 'resize');
        m.setZoom(x);
        m.setCenter(c);
    }
}

